var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("ribbon ribbon-" + _vm.placement)},[_c('span',[_c('font-awesome-icon',{attrs:{"icon":['fas', ("" + _vm.icon)]}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }